"use strict";

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.weak-map");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FollowGeneButtonFragmentContainer = exports.FollowGeneButton = void 0;

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.set-prototype-of");

require("core-js/modules/es6.object.define-property");

var _cohesion = require("@artsy/cohesion");

var Artsy = _interopRequireWildcard(require("../../Artsy"));

var _react = _interopRequireDefault(require("react"));

var _reactRelay = require("react-relay");

var _reactTracking = _interopRequireDefault(require("react-tracking"));

var _FollowButton = require("./FollowButton");

var _openAuthModal = require("../../Utils/openAuthModal");

var _AnalyticsContext = require("../../Artsy/Analytics/AnalyticsContext");

var _FollowGeneButtonMutation, _FollowGeneButton_gene;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var FollowGeneButton =
/*#__PURE__*/
function (_React$Component) {
  _inherits(FollowGeneButton, _React$Component);

  function FollowGeneButton() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, FollowGeneButton);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(FollowGeneButton)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "trackFollow", function () {
      var _this$props = _this.props,
          tracking = _this$props.tracking,
          _this$props$gene = _this$props.gene,
          is_followed = _this$props$gene.is_followed,
          internalID = _this$props$gene.internalID,
          slug = _this$props$gene.slug,
          contextModule = _this$props.contextModule,
          contextPageOwnerId = _this$props.contextPageOwnerId,
          contextPageOwnerSlug = _this$props.contextPageOwnerSlug,
          contextPageOwnerType = _this$props.contextPageOwnerType;
      var trackingData = {
        contextModule: contextModule,
        contextOwnerId: contextPageOwnerId,
        contextOwnerSlug: contextPageOwnerSlug,
        contextOwnerType: contextPageOwnerType,
        ownerId: internalID,
        ownerSlug: slug
      };
      var analyticsData = is_followed ? (0, _cohesion.unfollowedGene)(trackingData) : (0, _cohesion.followedGene)(trackingData);
      tracking.trackEvent(analyticsData);
    });

    _defineProperty(_assertThisInitialized(_this), "handleFollow", function () {
      var _this$props2 = _this.props,
          contextModule = _this$props2.contextModule,
          gene = _this$props2.gene,
          user = _this$props2.user,
          relay = _this$props2.relay,
          mediator = _this$props2.mediator;

      if (user && user.id) {
        (0, _reactRelay.commitMutation)(relay.environment, {
          mutation: _FollowGeneButtonMutation !== void 0 ? _FollowGeneButtonMutation : (_FollowGeneButtonMutation = require("../../__generated__/FollowGeneButtonMutation.graphql"), _FollowGeneButtonMutation.hash && _FollowGeneButtonMutation.hash !== "6e730f396b1bfca255e1e35cb6913dda" && console.error("The definition of 'FollowGeneButtonMutation' appears to have changed. Run `relay-compiler` to update the generated files to receive the expected data."), _FollowGeneButtonMutation),
          variables: {
            input: {
              geneID: gene.internalID
            }
          },
          optimisticResponse: {
            followGene: {
              gene: {
                id: gene.id,
                is_followed: !gene.is_followed
              }
            }
          }
        });

        _this.trackFollow();
      } else {
        (0, _openAuthModal.openAuthToFollow)(mediator, {
          entity: gene,
          contextModule: contextModule,
          intent: _cohesion.Intent.followGene
        });
      }
    });

    return _this;
  }

  _createClass(FollowGeneButton, [{
    key: "render",
    value: function render() {
      var gene = this.props.gene;
      return _react.default.createElement(_FollowButton.FollowButton, {
        isFollowed: gene && gene.is_followed,
        handleFollow: this.handleFollow
      });
    }
  }]);

  return FollowGeneButton;
}(_react.default.Component);

exports.FollowGeneButton = FollowGeneButton;
var FollowGeneButtonFragmentContainer = (0, _reactTracking.default)({})((0, _reactRelay.createFragmentContainer)(Artsy.withSystemContext((0, _AnalyticsContext.withAnalyticsContext)(FollowGeneButton)), {
  gene: _FollowGeneButton_gene !== void 0 ? _FollowGeneButton_gene : (_FollowGeneButton_gene = require("../../__generated__/FollowGeneButton_gene.graphql"), _FollowGeneButton_gene.hash && _FollowGeneButton_gene.hash !== "76484c1820e13b5b07970107b5e1f5ca" && console.error("The definition of 'FollowGeneButton_gene' appears to have changed. Run `relay-compiler` to update the generated files to receive the expected data."), _FollowGeneButton_gene)
}));
exports.FollowGeneButtonFragmentContainer = FollowGeneButtonFragmentContainer;
//# sourceMappingURL=FollowGeneButton.js.map